import { Tabs, TabsContent, TabsList, TabsTrigger } from '@design-system';
import {
  EmailTab,
  LinkTab,
  FillIntakeFormTab,
  useInviteClientTrigger,
  type TabType,
} from '@/features/invite-client';

import { ClipboardPen, Link2, Mail } from 'lucide-react';

export function InviteClientTabs() {
  const { inviteClientTab, setInviteClientTab } = useInviteClientTrigger();

  const currentTab = inviteClientTab || 'email';

  return (
    <Tabs
      value={currentTab}
      onValueChange={value => setInviteClientTab(value as TabType)}
      className="w-full"
    >
      <TabsList className="w-full">
        <TabsTrigger
          value="email"
          className="flex-1 gap-2"
        >
          <Mail className="hidden size-4 sm:block" />
          Invite via Email
        </TabsTrigger>
        <TabsTrigger
          value="link"
          className="flex-1 gap-2"
        >
          <Link2 className="hidden size-4 sm:block" />
          Share via link
        </TabsTrigger>
        <TabsTrigger
          value="fill-form"
          className="flex-1 gap-2"
        >
          <ClipboardPen className="hidden size-4 sm:block" />
          Fill Intake Form
        </TabsTrigger>
      </TabsList>
      <TabsContent
        value="email"
        className="mt-4"
      >
        <EmailTab />
      </TabsContent>
      <TabsContent
        value="link"
        className="mt-4"
      >
        <LinkTab />
      </TabsContent>
      <TabsContent
        value="fill-form"
        className="mt-4"
      >
        <FillIntakeFormTab />
      </TabsContent>
    </Tabs>
  );
}
